import { useState } from "react";
import EvaluationSlider from "../EvaluationSlider";

const OpenQuestion = ({
  question,
  activeQuestionAnswer,
  isEditable = false,
  onScoreChange,
  onFeedbackChange,
}) => {
  let textResponse = activeQuestionAnswer?.answer;
  if (typeof textResponse === "object" && textResponse !== null) {
    textResponse = textResponse.answer;
  }
  textResponse = textResponse || "";

  const initialScore =
    activeQuestionAnswer?.score !== undefined ? activeQuestionAnswer.score : 0;
  const initialFeedback = activeQuestionAnswer?.feedback || "";

  const [localScore, setLocalScore] = useState(initialScore);
  const [localFeedback, setLocalFeedback] = useState(initialFeedback);

  const handleScoreChange = (val) => {
    if (!isEditable) return;
    setLocalScore(val);
    if (onScoreChange) onScoreChange(val);
  };

  const handleFeedbackChange = (val) => {
    if (!isEditable) return;
    setLocalFeedback(val);
    if (onFeedbackChange) onFeedbackChange(val);
  };

  return (
    <div
      className="open-question-container mt-3"
      style={{ direction: "rtl", fontFamily: "inherit" }}
    >
      {question?.questionText && (
        <div
          className="p-3 border bg-white mb-3"
          style={{
            borderRadius: "8px",
            borderColor: "#ebebeb",
            boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
          }}
        >
          <div className="fw-bold fs-16 text-end" style={{ color: "#242424" }}>
            {question.questionText}
          </div>
        </div>
      )}

      <div
        className="p-3 border bg-white mb-4 text-end"
        style={{
          borderRadius: "8px",
          borderColor: "#ebebeb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
        }}
      >
        <div
          className="fs-16"
          style={{
            color: "#242424",
            whiteSpace: "pre-line",
            lineHeight: "1.7",
          }}
        >
          {textResponse || (
            <span className="text-muted italic-text">
              لم يتم تقديم إجابة مكتوبة
            </span>
          )}
        </div>
      </div>

      <div
        className="p-4 border bg-white"
        style={{
          borderRadius: "8px",
          borderColor: "#ebebeb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
        }}
      >
        <EvaluationSlider
          score={localScore}
          feedback={localFeedback}
          isEditable={isEditable}
          onScoreChange={handleScoreChange}
          onFeedbackChange={handleFeedbackChange}
          title="تقييم المعلم (درجة)"
        />
      </div>
    </div>
  );
};

export default OpenQuestion;
